export default __webpack_public_path__ + "static/media/caution.1c78f5f6.png";